// @flow

import React from "react";

type Props = {
  videoElementRef: (el: HTMLVideoElement) => void
};

const LiveSource = (props: Props) => {
  return (
    <div>
      <video ref={(props.videoElementRef: any)} />
    </div>
  );
};

export default LiveSource;



// WEBPACK FOOTER //
// ./src/LiveSource/LiveSource.js